<span *ngIf="imdbRating" class="d-flex align-items-center imdb">
    <span *ngIf="imdbLink" (click)="goToLink(imdbLink)">IMDb</span>
    <span *ngIf="!imdbLink">IMDb</span> 
    <span class="imdb-rating">
        {{imdbRating}}
    </span>
</span>


